
import { Component, Vue } from "vue-property-decorator";
import FormularioComponent from "@/components/Formulario2026/FormularioComponent.vue";

@Component({
  components: {
    FormularioComponent
  }
})
export default class FormularioView extends Vue {}
